import { mobileOrNot } from "./mobileDetect";

export function exitButtonPosition() {
  // This functions sets the position to exit button that is visible in puzzles and 2D Image view.
  let styles = {
    "#consoleLock": () =>
      mobileOrNot()
        ? `position: relative; top: -${
            document.querySelector("#consoleLock").clientHeight
          }px; left: 0px; transform: translate(15%,270%);`
        : `position: relative; top: -${
            document.querySelector("#consoleLock").clientHeight
          }px; left: 0px; transform: translate(30%,150%);`,
    ".poster-container": () =>
      `position: relative; top: 0px; left: 0px; transform: translate(15%,15%);`,
    "#parentTwitterWrapper": () =>
      `position: absolute; top: 0px; left: 0px; transform: unset;`,
       ".login-screen": () => `/* this has special rule see below /* `,
    ".show-tip-container": () => `display: initial;`,

    ".electricPanel .console": () =>
      `    position: absolute;
      top: 10px; left: 10px;`,
    "#parentFacebookWrapper": () => "position: absolute; left: 15px; top: 5px;",
    "#parentInstaWrapper": () => "left: 10px; top: 10px;",
    "#parentEmailWrapper": () => "left: 10px; top: 10px",
    ".wall-switch-container": () => "position: absolute; transform: unset; left: 10px; top: 10px",
    ".clock-container": () =>
      `position: inherit; top: ${mobileOrNot() ? "76px" : "inherit"}; left: ${
        mobileOrNot() ? "20px" : "inherit"
      }; transform: inherit; `,
    ".locker-container": () =>
      "position: absolute; top: 20px; left: 10px; transform: unset;",
    "#parentCameraWrapper": () =>
      "position: absolute; top: 10px; left: 10px; transform: unset;",
    ".plain-2d-image-container": () =>
      "position: absolute; top: 10px; left: 10px; transform: none;",
  };

  const addCssToexitButton = () => {
    let targets = Object.keys(styles);

    const currentVisible = targets.find((element) => {
      return document.querySelector(element);
    });

    const exitButton = document.querySelector(".exit-button")

    exitButton.style.display = "block";

    if(currentVisible === ".login-screen"){
      exitButton.style.cssText += `display: none;` 
      return
    }
    

    console.log(currentVisible);
    if (!document.querySelector(currentVisible)) return;
    document
      .querySelector(currentVisible)
      .appendChild(document.querySelector(".exit-button")).style.cssText +=
      "; " + styles[currentVisible]();
  };

  addCssToexitButton();
}
